import React from "react";
import { TicketsTaskbarCard } from "../tickets-taskbar-cards/tickets-taskbar-card";
import styles from "./taskbar-tickets-history-popover.module.scss";
import { SupportAgentTicket } from "@src/types/support";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { useI18N } from "@src/language/language-context";

const cssClassName = "taskbar-tickets-history-popover";

interface TaskbarTicketsHistoryPopoverProps {
  tickets: SupportAgentTicket[];
  patchLoadingIds: string[];
  wrapperRef: React.RefObject<HTMLDivElement>;
  handleCloseIconClick: (
    e: React.MouseEvent<HTMLButtonElement>,
    ticketId: string,
  ) => void;
  handleToggleTicketHistory: () => void;
  isMarkAsDoneDisabled?: boolean;
  disabledMarkAsDoneTooltip?: string;
}

export const TaskbarTicketsHistoryPopover = ({
  tickets,
  patchLoadingIds,
  wrapperRef,
  handleCloseIconClick,
  handleToggleTicketHistory,
  isMarkAsDoneDisabled = false,
  disabledMarkAsDoneTooltip = "",
}: TaskbarTicketsHistoryPopoverProps) => {
  const i18n = useI18N();

  const texts = {
    title: i18n("modules.taskbarTicketsHistoryPopover.title"),
    closeButtonText: i18n(
      "modules.taskbarTicketsHistoryPopover.closeButtonText",
    ),
  };

  useClickOutsideListener(wrapperRef, handleToggleTicketHistory, true);

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__header`]}>
        <span className={styles[`${cssClassName}__title`]}>{texts.title}</span>
        <button
          className={styles[`${cssClassName}__close-all`]}
          onClick={handleToggleTicketHistory}
        >
          {texts.closeButtonText}
        </button>
      </div>

      <div className={styles[`${cssClassName}__list`]}>
        {tickets.slice(3, tickets.length).map((ticket) => (
          <TicketsTaskbarCard
            key={ticket.id}
            ticket={ticket}
            patchLoading={patchLoadingIds.includes(ticket.id)}
            handleCloseIconClick={handleCloseIconClick}
            isMarkAsDoneDisabled={isMarkAsDoneDisabled}
            disabledMarkAsDoneTooltip={disabledMarkAsDoneTooltip}
          />
        ))}
      </div>
    </div>
  );
};
